<template>
    <div v-if="show" class="alert alert-box" :class="klass">
      <span class="text-left"><i class="fa fa-exclamation-circle"></i></span>
      {{ message }}
    </div>
</template>

<script>
export default {
  props : [
    'dataNotification'
  ],
  data() {
    return {
      defaultClass: 'alert-primary',
      message: '',
      klass: '',
      show: false
    };
  },
  created() {
    if (this.dataNotification) {
      this.flash(this.parseNotif(this.dataNotification));
    }

    window.events.$on('notify', this.flash);
  },
  methods: {
    parseNotif(notif) {
      try {
        return JSON.parse(notif);
      } catch (error) {
        return notif;
      }
    },
    flash(notification) {
      if (typeof notification == 'object') {
        this.message = notification.message;
        this.klass = `alert-${notification.class}`;
      } else {
        this.message = notification;
        this.klass = this.defaultClass;
      }

      this.show = true;

      this.hide();
    },
    hide() {
      setTimeout(() => this.show = false, 3000);
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/js/components/Admin/Notification.vue